<wm-modal-confirm *ngIf="workflowId" [form]="testAsClientForm" [showButton]="false" moduleId="testAsClient"
  id="testAsClient" title="Test as Client" (accepted)="testAsClient()" (canceled)="cancelTest()" (opened)="testAsClientModalOpened()"
  commandText="Test as Client" #testAsClientModal>
  <div *ngIf="testAsClientForm" [formGroup]="testAsClientForm">
    <div class="form-group" *ngIf="showTestAsClient">
      <label for="testAsClient">Select Client to Test As</label>
      <app-loader *ngIf="!testAsClients"></app-loader>
      <select *ngIf="testAsClients && testAsClientForm?.controls['testClient']" class="form-control"
        formControlName="testClient" [(ngModel)]="testAsClientData.clientId"
        (ngModelChange)="testAsClientSelected($event)">
        <option value="" disabled selected>Select Client</option>
        <option *ngFor="let client of testAsClients" [value]="client.id">
          {{ client.name }}
        </option>
      </select>
    </div>
    <ng-container *ngIf="testAsClients || testAsClientData?.clientId">
      <div class="form-group" *ngIf="needs?.needsParcelDataSource">
        <label for="testAsClientIteration">Parcel Data Source</label>
        <p *ngIf="!testAsClientData?.clientId" class="text-muted">
          This workflow requires Parcel Data. Select a jurisdiction to see if they have a Parcel Data Source configured.
        </p>
        <p *ngIf="noParcelDataSources" class="text-danger">
          <span *ngIf="testAsClientData?.clientId != _context.clientId">Your jurisdiction </span><span *ngIf="testAsClientData?.clientId != _context.clientId">The selected jurisdiction </span> does not have a Parcel Data Source setup. Please contact support to configure this for you.
        </p>
        <p *ngIf="testAsClientData?.clientId && !noParcelDataSources" class="text-muted">
          Parcel Data Source is configured for this jurisdiction.
        </p>
      </div>
      <div class="form-group" *ngIf="needs?.needsMapService">
        <label for="testAsClientIteration">Map Service</label>
        <p *ngIf="!testAsClientData?.clientId" class="text-muted">
          This workflow requires a Map Service. Select a jurisdiction to see their available map services.
        </p>
        <select
          *ngIf="testAsClientData?.clientId && testAsMapServices && testAsMapServices.length > 0 && testAsClientForm?.controls['testMapService']"
          class="form-control" formControlName="testMapService" [(ngModel)]="testAsClientData.mapServiceId">
          <option value="" disabled selected>Select Map Service</option>
          <option *ngFor="let ms of testAsMapServices" [value]="ms.id">
            {{ ms.name }}
          </option>
        </select>
        <p *ngIf="testAsMapServices && testAsMapServices?.length === 0 && testAsClientData?.clientId" class="text-danger">
          <span *ngIf="testAsClientData?.clientId != _context.clientId">Your jurisdiction </span><span *ngIf="testAsClientData?.clientId != _context.clientId">The selected jurisdiction </span>  does not have any Map Services available. Please contact support to configure a Map Service for this jurisdiction.
        </p>
      </div>
      <div class="form-group" *ngIf="needs?.needsContractorType">
        <label for="testAsClientIteration">Contractor Types</label>
        <p *ngIf="!testAsClientData?.clientId" class="text-muted">
          This workflow requires a Contractor Type. Select a jurisdiction to see the available contractor types.
        </p>
        <select
          *ngIf="testAsContractorTypes && testAsContractorTypes.length > 0 && testAsClientForm?.controls['testContractorType']"
          class="form-control" formControlName="testContractorType" [(ngModel)]="testAsClientData.contractorTypeId">
          <option value="" disabled selected>Select Contractor Type</option>
          <option *ngFor="let ct of testAsContractorTypes" [value]="ct.id">
            {{ ct.name }}
          </option>
        </select>
        <p *ngIf="testAsContractorTypes && testAsContractorTypes.length === 0 && testAsClientData?.clientId" class="text-danger">
          <span *ngIf="testAsClientData?.clientId != _context.clientId">Your jurisdiction </span><span *ngIf="testAsClientData?.clientId != _context.clientId">The selected jurisdiction </span> does not have any Contractor Types setup. Please setup at least one Contractor Type or contact support to configure this for you.
        </p>
      </div>
      <div class="form-group" *ngIf="!needs?.needsContractorType && !needs?.needsParcelDataSource && !needs?.needsMapService">
        <p class="text-muted">
          You can test this workflow without any additional data sources.
        </p>
      </div>
    </ng-container>
  </div>
</wm-modal-confirm>
